import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/ShopWifiStores/GET';

export const SHOP_WIFI_STORES_GET_SUCCESS = `${rootActionPath}_${SUCCESS_SUFFIX}`;
export const SHOP_WIFI_STORES_GET_FAILURE = `${rootActionPath}_${FAILURE_SUFFIX}`;
